import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Mic, MessageSquare, ShieldCheck } from 'lucide-react';

// Homepage banner for Campus Truth. Renders once, fires campus_truth_banner_view when
// scrolled into viewport, and fires campus_truth_banner_click on either CTA.
export default function CampusTruthBanner() {
  const ref = useRef(null);
  const viewedRef = useRef(false);

  useEffect(() => {
    if (!ref.current || viewedRef.current) return;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting && !viewedRef.current) {
          viewedRef.current = true;
          if (typeof window !== 'undefined' && window.gtag) {
            window.gtag('event', 'campus_truth_banner_view', { location: 'home' });
          }
        }
      });
    }, { threshold: 0.35 });
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  const onCtaClick = (which) => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'campus_truth_banner_click', { cta: which, location: 'home' });
    }
  };

  return (
    <section className="ct-home-banner" data-testid="ct-home-banner" ref={ref}>
      <div className="ct-home-banner-inner">
        <div className="ct-banner-glow" aria-hidden="true" />
        <div className="ct-banner-content">
          <div>
            <span className="ct-banner-eyebrow">CAMPUS TRUTH</span>
            <h2 className="ct-banner-title">Before you choose a college, hear from students living it.</h2>
            <p className="ct-banner-hindi">कॉलेज का असली सच जानें</p>
            <p className="ct-banner-body">Real written and voice reviews from students. No brochure talk. No sugar-coating. Just the real campus experience.</p>
            <div className="ct-banner-icons" aria-hidden="true">
              <span className="ct-banner-icon"><MessageSquare size={16} /> Written reviews</span>
              <span className="ct-banner-icon"><Mic size={16} /> Voice reviews</span>
              <span className="ct-banner-icon"><ShieldCheck size={16} /> Verified experiences</span>
            </div>
            <div className="ct-banner-ctas">
              <Link to="/campus-truth" onClick={() => onCtaClick('explore')} data-testid="ct-banner-primary" className="ct-banner-primary">Explore Campus Truth →</Link>
              <Link to="/campus-truth#rt-submission-form" onClick={() => onCtaClick('share')} data-testid="ct-banner-secondary" className="ct-banner-secondary">Share Your College Experience</Link>
            </div>
            <p className="ct-banner-reward">🎁 Share an honest verified review and become eligible for a CollegeUnlock Mystery Box.</p>
            <p className="ct-banner-trust">Positive, negative or mixed — honest experiences only.</p>
          </div>
          <div className="ct-banner-visual" aria-hidden="true">
            <div className="ct-banner-visual-text">
              <span className="ct-banner-visual-num">1st</span>
              <span className="ct-banner-visual-label">Verified student reviews platform for Indian colleges</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
